module.exports = __webpack_public_path__ + "MaterialIcons-Regular.a37b0c01c0baf1888ca8.ttf";


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/_storageApp.Front.release/~/@covalent/core/common/styles/font/MaterialIcons-Regular.ttf
// module id = ../../../../@covalent/core/common/styles/font/MaterialIcons-Regular.ttf
// module chunks = 2